export const MEMBERTYPE = {
  ACTIVE: "ACTIVE",
  DEFERRED: "DEFERRED",
  ACTIVE_PENSIONER: "ACTIVE_PENSIONER",
  DEFERRED_PENSIONER: "DEFERRED_PENSIONER",
  PENSIONER: "PENSIONER",
  DEPENDENT_PENSIONER: "DEPENDENT_PENSIONER",
  // TODO - New persona
  INACTIVE: "INACTIVE",
  ACTIVE_SAVINGS: "ACTIVE_SAVINGS",
  DEFERRED_SAVINGS: "DEFERRED_SAVINGS",
  ACTIVE_SAVINGS_DRAWDOWN: "ACTIVE_SAVINGS_DRAWDOWN",
  DEFERRED_SAVINGS_DRAWDOWN: "DEFERRED_SAVINGS_DRAWDOWN",
  PENSIONER_DRAWDOWN: "PENSIONER_DRAWDOWN",
  DEPENDENT_PENSIONER_DRAWDOWN: "DEPENDENT_PENSIONER_DRAWDOWN",
};

export const DISPLAYGREETING = {
  GOOD_MORNING: "Good morning",
  GOOD_AFTERNOON: "Good afternoon",
  GOOD_EVENING: "Good evening",
};

//Array of investor ID for mockAPI
// export const MOCKAPI_INVESTOR_ID = [
//   "21696684",
//   "21696682",
//   "21696760",
//   "21696678",
//   "21696679",
//   "21696680",
//   "21696681",
//   "21696707",
//   "21696677",
// ];
//UAT - Investor mock ids
export const MOCKAPI_INVESTOR_ID = [
  "21925013",
  "21925114",
  "21925070",
  "21925042",
  "21924932",
  "21925118",
];

//work item type
export const WORK_ITEM_TYPE = {
  WORK_ITEM_PERSONAL_DETAIL: "WORK_ITEM_PERSONAL_DETAIL",
  WORK_ITEM_CONTACT_DETAIL: "WORK_ITEM_CONTACT_DETAIL",
  WORK_ITEM_EMAIL_DETAIL: "WORK_ITEM_EMAIL_DETAIL",
  WORK_ITEM_ADDRESS_DETAIL: "WORK_ITEM_ADDRESS_DETAIL",
  WORK_ITEM_BANK_DETAIL: "WORK_ITEM_BANK_DETAIL",
  WORK_ITEM_BENEFIT_DETAIL: "WORK_ITEM_BENEFIT_DETAIL",
  WORK_ITEM_RETIREMENT_BANK: "WORK_ITEM_RETIREMENT_BANK",
};

//ID&V Status
export const IDV_STATUS = {
  UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
  PENDING: "JOURNEY_PENDING",
  SUCCESS: "JOURNEY_SUCCESS",
  FAILED: "JOURNEY_FAILED",
};

//ID&V time
export const IDV_DURATION = {
  QR_CODE_TIME: 180000,
  JOURNEY_INFO_API_CALL: 30000,
};

//Membership type
export const MEMBERSHIPTYPE = {
  DB_TRANSFER_IN: "DB Transfer In",
  DB_AVC: "DB AVC",
  HYBRID: "Hybrid",
  DC_MAIN_SCHEME: "DC Main Scheme",
  DC_AVC_PAYER: "DC AVC Payer",
  DC_TVIN: "DC Tvin",
};

//fundType
export const FUNDTYPE = {
  SELF_MANAGED: "Self-managed",
  MANAGED_FOR_ME: "Managed for me",
  PENDING_TRANSACTIONS: "Pending transactions",
};

//personal detail - my detail country options
export const countryOptions = [
  {
    value: "GBR",
    option: "United Kingdom",
  },
  {
    value: "US",
    option: "United States",
  },
  {
    value: "IN",
    option: "India",
  },
];

export const RA_STEPS_IDENTIFIERS = {
  RETIREMENT_DATE_AND_GUIDANCE: "RETIREMENT_DATE_AND_GUIDANCE",
  OTHER_PENSIONS: "OTHER_PENSIONS",
  CHOOSING_YOUR_RETIREMENT: "CHOOSING_YOUR_RETIREMENT",
  BANK_MANDATE: "BANK_MANDATE",
  IDENTITY_AND_VERIFICATION: "IDENTITY_AND_VERIFICATION",
  DECLARATION: "DECLARATION",

  RA_APPLICATION_WAKE_UP_INFO: "RA_APPLICATION_WAKE_UP_INFO",
  RA_APPLICATION_DATE: "RA_APPLICATION_DATE",
  RA_PENSION_WISE: "RA_GUIDE_AND_ADVICE",
  RA_OTHER_PENSIONS: "RA_OTHER_PENSIONS",
  RA_LUMP_SUM_ALLOWANCES: "RA_LUMPSUM",
  RA_OFFLINE_PENSION: "RA_OFFLINE_PENSION",
  RA_POT_SELECTION: "RA_POT_SELECTION",
  RA_RETIREMENT_CHOICE: "RA_RETIREMENT_CHOICE",
  BANK_MANDATE_CONFIRM: "BANK_MANDATE_CONFIRM",
  RA_IDENTITY_AND_VERIFICATION: "RA_IDENTITY_AND_VERIFICATION",
  RA_DECLARATION_CONFIRM: "RA_DECLARATION_CONFIRM",
  RA_ILLUSTRATION: "RA_ILLUSTRATION",
  RA_CONFIRM_DETAILS: "RA_CONFIRM_DETAILS",
  RA_CONFIRM_CHOICE: "RA_CONFIRM_CHOICE",
  RA_TAKE_MONEY_IN_CHUNKS: "RA_TAKE_MONEY_IN_CHUNKS",
  RA_TAKE_ALL_IN_ONE_GO: "RA_TAKE_ALL_IN_ONE_GO",
  RA_CONTRIBUTION: "RA_CONTRIBUTION",
  RA_TAX_FREE_CASH: "RA_TAX_FREE_CASH",
  RA_INVEST_THE_REST: "RA_INVEST_THE_REST",
  RA_ANNUITY_CHOICE: "RA_ANNUITY_CHOICE",
  RA_ANNUITY_PROVIDER: "RA_ANNUITY_PROVIDER",

  RA_RI_CASH_LUMPSUM: "RA_RI_CASH_LUMPSUM",
  RA_RI_INVEST_THE_REST: "RA_RI_INVEST_THE_REST",
  RA_MM_CASH_LUMPSUM: "RA_MM_CASH_LUMPSUM",
  RA_BEND_STRATEGIES: "RA_BEND_STRATEGIES",
  RA_APPLICATION_SUCCESS: "RA_APPLICATION_SUCCESS",
};

//Retirement application offline processes
export const RA_OFFLINE_PROCESSES = {
  RA_OFFLINE_ILL_HEALTH: "RA_OFFLINE_ILL_HEALTH",
  RA_OFFLINE_TAX_FREE: "RA_OFFLINE_TAX_FREE",
};

export const periodCheckBox = [
  { key: "Monthly", value: "Monthly" },
  { key: "Quarterly", value: "Quarterly" },
  { key: "6-monthly", value: "HalfYearly" },
  { key: "Once a Year", value: "Annually" },
];

//Strategies
export const STRATEGIES = {
  MANAGED_INCOME: "Managed Income",
  FUTURE_ANNUITY_INCOME: "Future annuity income",
  FLEXI_ACCESS: "Flexi-access",
  TAX_FREE_CASH_AS_INCOME: "Tax-free cash as income",
  SAFETY_NET: "Safety net",
  LEGACY: "Legacy",
  CASH: "Cash",
};

//Future growth estimate

export const FUTURE_GROWTH_ESTIMATE = {
  CAUTIOUS: "2",
  MEDIUM: "5",
  OPTIMISTIC: "8",
};
// Document page dropdown options
export const documentValueOptions = [
  {
    option: "Bringing other pensions to TPT",
    value: "Bringing other pensions to TPT",
  },
  {
    option: "Taking your pension (retirement)",
    value: "Taking your pension (retirement)",
  },
  {
    option: "Bereavement",
    value: "Bereavement",
  },
  {
    option: "Divorce",
    value: "Divorce",
  },
  {
    option: "Change investment",
    value: "Change investment",
  },
  {
    option: "Updating your details",
    value: "Updating your details",
  },
  {
    option: "Any other enquiry",
    value: "Any other enquiry",
  },
  {
    option: "Complaints",
    value: "Complaints",
  },
  {
    option: "Moving your TPT pension elsewhere",
    value: "Moving your TPT pension elsewhere",
  },
];

export const productsOptions = [
  {
    option: "All Memberships",
    value: "All Memberships",
  },
  {
    option: "Memberships 1",
    value: "Memberships 1",
  },
  {
    option: "Memberships 2",
    value: "Memberships 2",
  },
];

export const docDurationOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Last 3 months",
    value: "Last 3 months",
  },
  {
    option: "Last 6 months",
    value: "Last 6 months",
  },
  {
    option: "Last year",
    value: "Last year",
  },
];

export const docMsgCategoriesOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Transactions",
    value: "Transactions",
  },
  {
    option: "Servicing your account",
    value: "Servicing your account",
  },
  {
    option: "Plan changes",
    value: "Plan changes",
  },
  {
    option: "Payslips and tax",
    value: "Payslips and tax",
  },
  {
    option: "Statements",
    value: "Statements",
  },
];
//fundName
export const FUNDNAME = {
  SAVINGS: "savings",
  DRAWDOWN: "drawDown",
};

export const monthShortNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthFullNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
//withdraw category
export const WITHDRAW_CATEGORY = {
  FOR_INCOME: "For Income",
  SELF_MANAGED: "Self-managed",
  GROWTH: "For Growth",
};

//Your goals status
export const YOUR_GOALS_TASK_STATUS = {
  COMPLETED: "COMPLETED",
  NOT_STARTED: "NOT_STARTED",
};

export const messageDropdownOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Read",
    value: "Read",
  },
  {
    option: "Unread",
    value: "Unread",
  },
  {
    option: "Action required",
    value: "Action required",
  },
  {
    option: "High priority",
    value: "High priority",
  },
];
export const learnFilterDropdownOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Article",
    value: "Article",
  },
  {
    option: "Video",
    value: "Video",
  },
  {
    option: "Webinar",
    value: "Webinar",
  },
];

export const messageDropdownCategoryOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Email",
    value: "Email",
  },
  {
    option: "Transactions",
    value: "Transactions",
  },
  {
    option: "Quotations",
    value: "Quotations",
  },
  {
    option: "Income Payments",
    value: "Income Payments",
  },
  {
    option: "Payslips & Tax",
    value: "Payslips & Tax",
  },
  {
    option: "Scheduled or per...",
    value: "Scheduled or personal documents",
  },
  {
    option: "communication",
    value: "communication",
  },
];

export const messageDropdownMembershipOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Pension",
    value: "Pension",
  },
];

export const messageDropdownDurationOptions = [
  {
    option: "All",
    value: "All",
  },
  {
    option: "Last 3 months",
    value: "Last 3 months",
  },
  {
    option: "Last 6 months",
    value: "Last 6 months",
  },
];

export const groupTransaction = {
  All: [
    1, 59, 1238, 2273, 2324, 2405, 2457, 2952, 2592, 2953, 2955, 2960, 2376,
    2962, 1229, 2318, 2319, 2966, 2967, 2965, 2387, 2384, 2396, 2408, 2496,
    2768, 2958, 2679, 2680, 2769, 2938, 462, 2397, 2770, 2682, 2383, 2380, 2395,
    2403, 2404, 5, 2379, 2390, 2392, 2394, 2964, 2971, 2972, 2973, 2975, 2977,
    2979, 2981, 2983, 2937, 2987, 287,
  ],
  Adjustments: [59, 1229, 2273, 2405, 2952, 2592, 2953, 2955, 2960],
  Contributions: [1, 2376, 2962],
  Investment_instructions: [2318, 2319, 2966, 2967, 2965],
  Payments: [2387, 2384, 2396, 2408, 2496, 2768, 2958, 2679, 2680, 2769, 2987],
  Tax_and_charges: [2324, 2938, 462, 2397, 2770, 2682, 2383, 2937],
  Transfers: [
    1238, 2380, 2395, 2403, 2404, 5, 2379, 2390, 2392, 2394, 2457, 2964, 2971,
    2972, 2973, 2975, 2977, 2979, 2981, 2983, 287,
  ],
};

export const groupContribution = {
  Employee: ["employeeAmount", "employeeNoTaxAmount"],
  Employer: ["employerAvcAmount", "employerAmount", "salSacrificeAmount"],
  AVC: ["employeeAvcAmount"],
};

export const desiredOrder = [
  "Blank option",
  "Miss",
  "Mrs",
  "Ms",
  "Mme",
  "Mr",
  "Mx",
  "Dr",
];

export const ERROR = {
  CLIENT_ERROR: "CLIENT_ERROR",
  NETWORK_ERROR: "NETWORK_ERROR",
  SERVER_ERROR: "SERVER_ERROR",
  ERROR_422: "ERROR_422",
};

export const ErrorMessages = {
  CLIENT_ERROR:
    "Apologies, we're currently facing technical issues. Please try refreshing this page, or try again later.",
  NETWORK_ERROR:
    "Apologies, we're not able to connect to server. Please check your internet connection.",
  SERVER_ERROR:
    "Apologies, we're unable to connect you. Please try refreshing this page, or try again later.",
  INVALID_DATA: "Invalid data, please contact administrator",
  INVALID_USER: "Invalid user, please contact administrator",
  REDIRECTING_SIGNIN: "Redirecting to sign in",
  SWITCH_ERROR:
    "We’re currently processing a transaction on your account, which means you can’t make changes at the moment. This can take up to 5 working days. Please try again once it’s complete.",
};

export const ManageInvestmentMessage = {
  ACCOUNT_LOCKED:
    "Changes are pending on all pots. No further updates can be made.",
  DRAWDOWN_MESSAGE: "Manage drawdown online is coming soon.",
  WITHDRAW_MESSAGE:
    "Drawdown withdrawal online is coming soon.  Until then, to make a withdrawal, please ",
};

export const manageInvestmentCards = {
  POWER_OF_PENSIONS: "The power of your pension: responsible investing",
  KEEPING_ON_TOP: "Keeping on top of your finances: how to deal with debt",
  FIVE_PENSION_TO_KNOW: "5 pension need-to-knows",
  OVER_VIEW_OF_PENSION: "Overview of pensions",
};

export const LikertOptions = {
  VERY_EASY: "Very easy",
  EASY: "Easy",
  NEUTRAL: "Neutral",
  DIFFICULT: "Difficult",
  VERY_DIFFICULT: "Very difficult",
};

export const MemberAccountType = {
  ACTIVE: "Active",
  DEFERRED: "Deferred",
  DRAWDOWN: "Drawdown",
  INACTIVE: "Inactive",
};

export const GBGMessage = {
  GBG_FAILED: "GBG_FAILED",
  GBG_PASSED: "GBG_PASSED",
};

export const inUat = true; // TODO - Switch to true for p1 feature deliverable and remove it once TPT ask for p2 features

export const erAmountType = {
  APS: "APS",
  RM: "RM",
  RPS: "RPS",
};

export const pensionWiseGuidanceCompletionContent = {
  RECEIVED_GUIDANCE_FROM_PENSIONWISE:
    "I received guidance from Pension Wise in relation to this application in the last 12 months",
  RECEIVED_ADVICE_FROM_FCA:
    "I received advice from an FCA regulated financial adviser in relation to this application in the last 12 months",
  WISH_TO_OPT_OUT_GUIDANCE_FROM_PW:
    "I opt out of receiving guidance from Pension Wise",
};

export const frequencySuffixMap = {
  Monthly: "p/m",
  Quarterly: "p/q",
  Annually: "p/a",
  HalfYearly: "p/6m",
};
// TODO - Disabled as per client requirement
export const disablePyfItems = true; // Disabling PYFs few specific feature to fasten up the testing and release process, just make it "false" once TPT asks to provide hidden feature later on

// TODO - Hide as per client requirement in pre-prod
export const hideDBonline = false; // Hiding the DB online link in pre-prod to avoid testers/users clicking back to production when they are testing unawares.

export const popupBlockerText =
  "To view or download this document, please enable pop-ups in your browser settings.";
